var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanClosedActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 22H0V4.58002L4.59 0H16V6H14V2H5.41L2 5.41V20H7V22Z",
    fill: "url(#paint0_linear_3151_4983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H2V5H5V2H7V7Z",
    fill: "url(#paint1_linear_3151_4983)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H11",
    stroke: "url(#paint2_linear_3151_4983)",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H11",
    stroke: "url(#paint3_linear_3151_4983)",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40625 9C7.94497 9 8.46163 9.2382 8.84256 9.66219C9.22349 10.0862 9.4375 10.6612 9.4375 11.2609C9.4375 11.8605 9.22349 12.4356 8.84256 12.8595C8.46163 13.2835 7.94497 13.5217 7.40625 13.5217H6L9.4375 17",
    stroke: "url(#paint4_linear_3151_4983)",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16L12 21",
    stroke: "url(#paint5_linear_3151_4983)",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21L12 16",
    stroke: "url(#paint6_linear_3151_4983)",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4983",
    x1: 8,
    y1: 24.037,
    x2: 8,
    y2: -2.85185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4983",
    x1: 4.5,
    y1: 7.46296,
    x2: 4.5,
    y2: 1.35185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4983",
    x1: 8.5,
    y1: 12.0926,
    x2: 8.5,
    y2: 10.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3151_4983",
    x1: 8.5,
    y1: 10.0926,
    x2: 8.5,
    y2: 8.87037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3151_4983",
    x1: 7.71875,
    y1: 17.7407,
    x2: 7.71875,
    y2: 7.96296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3151_4983",
    x1: 14.5,
    y1: 21.463,
    x2: 14.5,
    y2: 15.3519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3151_4983",
    x1: 14.5,
    y1: 21.463,
    x2: 14.5,
    y2: 15.3519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanClosedActive);
export default __webpack_public_path__ + "static/media/loan-closed-active.112d86fb24ca24ac45f00e04b8ff717c.svg";
export { ForwardRef as ReactComponent };